module.exports = "https://static-www.niulinkcloud.com/_next/static/media/pc.78cd7103bee0930567fc2715198a5df9.png";